var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.93,
    height: 62.934,
    viewBox: "0 0 62.93 62.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 51.13,
    height: 39.784,
    transform: "translate(1804.73 996.409)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M1822.431,996.409a17.7,17.7,0,1,0,0,35.4h15.153a2.45,2.45,0,0,1,1.1.26l7.723,3.862a2.459,2.459,0,0,0,3.558-2.2v-5.377a2.494,2.494,0,0,1,.74-1.757,17.7,17.7,0,0,0-12.54-30.188Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 51.134,
    height: 40.339,
    transform: "translate(1804.73 996.409)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M1816.53,1014.07a2.951,2.951,0,1,0,2.95-2.95,2.951,2.951,0,0,0-2.95,2.95",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -307.841,
    y1: 11.673,
    x2: -307.671,
    y2: 11.673,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5eaa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4e8a3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M1827.347,1014.07a2.95,2.95,0,1,0,2.951-2.95,2.951,2.951,0,0,0-2.951,2.95",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -309.725,
    y1: 11.673,
    x2: -309.555,
    y2: 11.673,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M1838.164,1014.07a2.95,2.95,0,1,0,2.95-2.95,2.951,2.951,0,0,0-2.95,2.95",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -311.552,
    y1: 11.673,
    x2: -311.382,
    y2: 11.673,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(-158 -131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(-793 -2407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(-841.93 1564.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M1826.364,973.259h-15.733a17.7,17.7,0,0,0-12.541,30.188,2.5,2.5,0,0,1,.741,1.758v5.377a2.457,2.457,0,0,0,3.557,2.2l7.724-3.861a2.45,2.45,0,0,1,1.1-.26h15.153a17.7,17.7,0,0,0,0-35.4",
    fill: "#e5c923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M1826.364,990.921a2.95,2.95,0,1,0,2.95-2.95,2.95,2.95,0,0,0-2.95,2.95",
    fill: "#fbf6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M1815.547,990.921a2.95,2.95,0,1,0,2.95-2.95,2.95,2.95,0,0,0-2.95,2.95",
    fill: "#fbf6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M1804.73,990.921a2.95,2.95,0,1,0,2.95-2.95,2.95,2.95,0,0,0-2.95,2.95",
    fill: "#fbf6da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(-841.93 1564.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M1822.431,996.409h15.732A17.7,17.7,0,0,1,1850.7,1026.6a2.5,2.5,0,0,0-.74,1.758v5.377a2.458,2.458,0,0,1-3.558,2.2l-7.724-3.861a2.451,2.451,0,0,0-1.1-.26h-15.152a17.7,17.7,0,1,1,0-35.4",
    fill: "#fefdf8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    width: 51.84,
    height: 40.8,
    transform: "translate(1804.32 996)",
    xlinkHref: "data:image/png;base64,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"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(-841.93 1564.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    width: 5.901,
    height: 5.901,
    transform: "translate(1816.53 1011.12)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(-841.93 1564.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 5.9,
    height: 5.901,
    transform: "translate(1827.347 1011.12)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(-841.93 1564.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 5.9,
    height: 5.901,
    transform: "translate(1838.164 1011.12)",
    fill: "url(#linear-gradient-3)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.c38ab7059a8258d2de4e559d11b77102.svg";
export { ForwardRef as ReactComponent };